import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-header" }
const _hoisted_2 = { class: "kpis" }
const _hoisted_3 = { class: "kpi" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "kpi" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = {
  key: 0,
  class: "tasks-count"
}
const _hoisted_12 = { class: "tasks-count__label" }

import { computed } from "vue";
import TileBase from "./TileBase.vue";
import TileTitle from "./TileTitle.vue";
import useProjectBudget from "@/composables/UseProjectBudget";
import { type Project } from "@/helpers/project/typesDefinition";
import { formatPrice } from "@/helpers/utils";
import Badge from "./Badge.vue";
import { Icon } from "@iconify/vue";
import ProgressBar from "./ProgressBar.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectCard',
  props: {
    title: {},
    project: {}
  },
  setup(__props: any) {

const props = __props;

const { totalAmount, invoicedAmount, invoicedPercentage, performedAmount } =
  useProjectBudget(props.project, props.project?.themes);

const tasksCount = computed(() => {
  return props.project?.clientActions.length;
});

const isDanger = computed(() => {
  return (invoicedAmount.value ?? 0) > (totalAmount.value ?? 0);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TileBase, { class: "tile-project" }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createVNode(TileTitle, {
          class: "project-title",
          level: 4,
          title: __props.title
        }, {
          default: _withCtx(() => [
            _createVNode(Badge, {
              color: __props.project.color
            }, null, 8, ["color"])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("div", null, [
          (_unref(invoicedPercentage) != undefined)
            ? (_openBlock(), _createBlock(ProgressBar, {
                key: 0,
                "danger-percent": 1,
                percentages: _unref(invoicedPercentage),
                color: __props.project.color
              }, null, 8, ["percentages", "color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("project.budget.label.total")), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatPrice)(_unref(totalAmount))), 1)
          ]),
          (!__props.project.internal)
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: _normalizeClass(['kpi', { 'kpi--danger': isDanger.value }])
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("project.budget.label.invoiced")), 1),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatPrice)(_unref(invoicedAmount))), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("project.budget.label.performed")), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatPrice)(_unref(performedAmount))), 1)
          ])
        ]),
        (tasksCount.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_unref(Icon), {
                class: "tasks-count__icon",
                icon: "mdi:checkbox-marked-outline"
              }),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("labels.openedTasks")), 1),
              _createVNode(Badge, {
                "color-name": "error",
                label: tasksCount.value,
                class: "tasks-count__badge"
              }, null, 8, ["label"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})